export const setShadowRootStyle = (
  element: HTMLElement | null,
  selectors: keyof HTMLElementTagNameMap,
  styleProperty: string,
  styleValue: string,
  important?: boolean
) =>
  element?.shadowRoot
    ?.querySelector(selectors)
    ?.style?.setProperty(
      styleProperty,
      styleValue,
      important ? 'important' : undefined
    );
